var _g, _rect, _path, _path2, _path3, _circle, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSliver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 273,
    height: 81,
    viewBox: "0 0 273 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26_3525)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 25,
    width: 273,
    height: 56,
    rx: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79,
    y: 23.233,
    width: 9,
    height: 82.8592,
    transform: "rotate(-35.5519 79 23.233)",
    fill: "#4B4B4B",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83,
    y: 23.233,
    width: 9,
    height: 82.8592,
    transform: "rotate(-35.5519 83 23.233)",
    fill: "#4B4B4B",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83,
    y: 23.233,
    width: 208.57,
    height: 170.111,
    transform: "rotate(-35.5519 83 23.233)",
    fill: "#4B4B4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.71 61.308C131.476 61.308 129.408 59.768 128.55 57.502L131.586 55.742C132.136 57.018 133.082 57.876 134.82 57.876C136.492 57.876 136.91 57.216 136.91 56.622C136.91 55.676 136.03 55.302 133.72 54.664C131.432 54.026 129.188 52.926 129.188 49.978C129.188 47.008 131.696 45.292 134.358 45.292C136.888 45.292 138.868 46.502 139.99 48.768L137.02 50.506C136.492 49.406 135.766 48.724 134.358 48.724C133.258 48.724 132.708 49.274 132.708 49.89C132.708 50.594 133.082 51.078 135.48 51.804C137.812 52.508 140.43 53.322 140.43 56.578C140.43 59.548 138.054 61.308 134.71 61.308ZM142.082 45.6H145.602V61H142.082V45.6ZM151.768 57.612H157.268V61H148.248V45.6H151.768V57.612ZM161.204 61L156.188 45.6H160.038L163.448 56.93L166.858 45.6H170.708L165.692 61H161.204ZM175.551 57.612H181.711V61H172.031V45.6H181.601V48.988H175.551V51.54H181.051V54.884H175.551V57.612ZM191.793 61L188.889 55.94H187.217V61H183.697V45.6H189.857C192.783 45.6 195.137 47.954 195.137 50.88C195.137 52.772 193.993 54.488 192.299 55.346L195.577 61H191.793ZM187.217 48.9V52.86H189.857C190.825 52.86 191.617 52.002 191.617 50.88C191.617 49.758 190.825 48.9 189.857 48.9H187.217ZM213.072 45.6V48.988H209.112V61H205.592V48.988H201.632V45.6H213.072ZM214.613 45.6H218.133V61H214.613V45.6ZM224.299 57.612H230.459V61H220.779V45.6H230.349V48.988H224.299V51.54H229.799V54.884H224.299V57.612ZM240.541 61L237.637 55.94H235.965V61H232.445V45.6H238.605C241.531 45.6 243.885 47.954 243.885 50.88C243.885 52.772 242.741 54.488 241.047 55.346L244.325 61H240.541ZM235.965 48.9V52.86H238.605C239.573 52.86 240.365 52.002 240.365 50.88C240.365 49.758 239.573 48.9 238.605 48.9H235.965Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.678 51.8253C68.0782 52.2525 64.2297 49.5444 63.4926 49.5385C62.7555 49.5326 58.8637 52.1784 58.2709 51.7416C57.6781 51.3048 59.0717 46.8182 58.8497 46.1173C58.6276 45.4165 54.9014 42.5433 55.1348 41.8461C55.3682 41.1489 60.0781 41.0842 60.6778 40.657C61.2776 40.2298 62.8666 35.8082 63.6037 35.8141C64.3407 35.82 65.8579 40.2666 66.4507 40.7034C67.0435 41.1402 71.7517 41.2808 71.9738 41.9816C72.1959 42.6824 68.4238 45.4953 68.1903 46.1925C67.9569 46.8897 69.2778 51.3981 68.678 51.8253Z",
    fill: "url(#paint0_linear_26_3525)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 25.5,
    width: 272,
    height: 55,
    rx: 9.5,
    stroke: "url(#paint1_linear_26_3525)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M51.2171 53.2797L44.2137 49.8894L36.3102 59.3148L34.9832 57.431L36.635 44.7606L30.0926 25.0684L15.0991 30.3766L19.0926 40.4299L31.9269 71.3263L34.7574 78.3266L35.0852 76.2942L38.2126 64.3694L42.5835 59.5159L50.388 58.9158L37.959 50.3132L51.2171 53.2797Z",
    fill: "#010101",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1439 16.203C43.7805 16.203 47.5392 12.5758 47.5392 8.10148C47.5392 3.62716 43.7805 0 39.1439 0C34.5073 0 30.7485 3.62716 30.7485 8.10148C30.7485 12.5758 34.5073 16.203 39.1439 16.203Z",
    fill: "#C2C2C2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3015 65.0065L56.1944 67.5709C54.7095 64.7467 51.5605 62.8752 47.9939 63.1598C43.8209 63.4938 40.4925 66.8501 40.3193 70.887C40.2543 72.3934 40.6131 73.8164 41.2999 75.0475L40.9534 75.2207L38.2251 76.588L34.7605 78.3265C32.9726 74.2896 31.4599 70.2374 30.1824 66.2377C29.9751 65.5973 29.774 64.9508 29.5823 64.3105V64.3043C29.44 63.8341 29.2977 63.3516 29.1894 62.9773C29.0811 62.6061 29.0069 62.3493 29.0069 62.3493C26.7147 54.353 25.3134 46.6846 24.472 39.9566L24.4782 40.0865C23.3584 32.7026 23.3027 24.663 23.3027 24.663C23.2656 23.3267 23.2563 22.1172 23.2563 21.05C23.2563 20.4035 23.2564 19.8065 23.2687 19.2682C23.3028 17.1276 23.3801 15.8624 23.3894 15.683V15.6614L27.8624 16.2677L30.1205 16.6451C30.105 16.843 30.0958 17.0441 30.0958 17.2452C30.0958 21.7213 33.8542 25.3467 38.488 25.3467C42.3547 25.3467 45.6058 22.8287 46.5802 19.3981L48.993 19.8003L52.6741 20.4468V20.4623C52.6648 20.5891 52.5659 22.3956 52.5782 25.3003C52.5782 25.3003 52.7917 33.4914 53.1381 36.6528C53.5743 41.1351 54.3105 46.0999 55.5571 50.9534C55.5633 50.9689 55.5664 50.9812 55.5695 50.9967C56.0397 52.9053 56.1046 52.9641 56.1077 52.9641C57.3575 57.2855 59.0402 61.443 61.3046 65.0034L61.3015 65.0065Z",
    fill: "#626365"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 63.2274,
    cy: 44.3536,
    r: 13.9054,
    stroke: "url(#paint2_linear_26_3525)",
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_26_3525",
    x1: 55.1243,
    y1: 43.8426,
    x2: 71.9833,
    y2: 43.8426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEBEBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_26_3525",
    x1: 5.08502e-7,
    y1: 53,
    x2: 136.1,
    y2: 82.8238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_26_3525",
    x1: 63.2274,
    y1: 30.1982,
    x2: 63.2274,
    y2: 58.509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B5B5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26_3525"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 25,
    width: 273,
    height: 56,
    rx: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliver);
export default __webpack_public_path__ + "static/media/Sliver.0c3ac90ad5852d074f49ff5dbbf2c208.svg";
export { ForwardRef as ReactComponent };